import hiraokaImage from './images/cast/hiraoka.png';
import hiraokaLesson1Image from './images/cast/hiraoka1.png';
import hiraokaLesson2Image from './images/cast/hiraoka2.png';
import hiraokaLesson3Image from './images/cast/hiraoka3.png';
import hiraokaMainImage from './images/cast/hiraoka_yoshihiro.png';
import itagakiImage from './images/cast/itagaki.png';
import itagakiLesson1Image from './images/cast/itagaki1.png';
import itagakiLesson2Image from './images/cast/itagaki2.png';
import itagakiLesson3Image from './images/cast/itagaki3.png';
import itagakiMainImage from './images/cast/itagaki_koji.png';
import morizonoImage from './images/cast/morizono.png';
import morizonoLesson1Image from './images/cast/morizono1.png';
import morizonoLesson2Image from './images/cast/morizono2.png';
import morizonoLesson3Image from './images/cast/morizono3.png';
import morizonoMainImage from './images/cast/morizono_masataka.png';
import oikawaImage from './images/cast/oikawa.png';
import oikawaLesson1Image from './images/cast/oikawa1.png';
import oikawaLesson2Image from './images/cast/oikawa2.png';
import oikawaLesson3Image from './images/cast/oikawa3.png';
import oikawaMainImage from './images/cast/oikawa_mizuki.png';
import qiuImage from './images/cast/qiu.png';
import qiuLesson1Image from './images/cast/qiu1.png';
import qiuLesson2Image from './images/cast/qiu2.png';
import qiuLesson3Image from './images/cast/qiu3.png';
import qiuMainImage from './images/cast/qiu_kenshin.png';
import suzukiImage from './images/cast/suzuki.png';
import suzukiLesson1Image from './images/cast/suzuki1.png';
import suzukiLesson2Image from './images/cast/suzuki2.png';
import suzukiLesson3Image from './images/cast/suzuki3.png';
import suzukiMainImage from './images/cast/suzuki_rika.png';
import yamamotoImage from './images/cast/yamamoto.png';
import yamamotoLesson1Image from './images/cast/yamamoto1.png';
import yamamotoLesson2Image from './images/cast/yamamoto2.png';
import yamamotoLesson3Image from './images/cast/yamamoto3.png';
import yamamotoMainImage from './images/cast/yamamoto_rei.png';
import yoshimuraImage from './images/cast/yoshimura.png';
import yoshimuraLesson1Image from './images/cast/yoshimura1.png';
import yoshimuraLesson2Image from './images/cast/yoshimura2.png';
import yoshimuraLesson3Image from './images/cast/yoshimura3.png';
import yoshimuraMainImage from './images/cast/yoshimura_maharu.png';

type CastModalLesson = {
  image: StaticImageData;
  title: string;
};

type CastModal = {
  description: string;
  image: StaticImageData;
  lessons: CastModalLesson[];
};

export type CastDetail = {
  name: string;
  title: string;
  description1: string;
  description2: string;
  image: StaticImageData;
  romajiName: string;
  modal: CastModal;
};

export const castDetails: CastDetail[] = [
  {
    name: '平岡義博',
    title: '監督',
    description1: '元 明治大学卓球部監督',
    description2: '吉村真晴選手などトップ選手の指導経験あり',
    image: hiraokaMainImage,
    romajiName: 'hiraoka',
    modal: {
      description:
        '卓球の名門、元明治大学卓球部監督。強豪チームや協会、連盟の技術アドバイザーを行い、多数（宇田、吉村）のトップ選手を指導。',
      image: hiraokaImage,
      lessons: [
        {
          image: hiraokaLesson1Image,
          title: '【必見】サービスエースを量産！平岡義博の最新サーブ講座！',
        },
        {
          image: hiraokaLesson2Image,
          title: 'トップ選手のアドバイスに潜む罠！？',
        },
        {
          image: hiraokaLesson3Image,
          title: '役割分担が大事！フリーハンドと下半身の関係',
        },
      ],
    },
  },
  {
    name: '板垣孝司',
    title: '監督',
    description1: '元 青森山田卓球部監督',
    description2: 'ドイツブンデスリーガ1部の監督',
    image: itagakiMainImage,
    romajiName: 'itagaki',
    modal: {
      description:
        '元青森山田学園卓球部監督、現ドイツプロリーグ1部チームのヘッドコーチ。初心者からトップ選手、ジュニア選手に有効な練習方法をご紹介。',
      image: itagakiImage,
      lessons: [
        {
          image: itagakiLesson1Image,
          title: '板垣孝司のジュニア指導。8分で劇的に上達するシリーズ',
        },
        {
          image: itagakiLesson2Image,
          title: '得点するバックハンド。選手を強くする指導法',
        },
        {
          image: itagakiLesson3Image,
          title: '世界で通用する「バックハンド」プロの打ち方を解説',
        },
      ],
    },
  },
  {
    name: '吉村真晴',
    title: '選手',
    description1: 'リオ五輪 団体銀メダル',
    description2: ' 世界卓球混合ダブルス 金メダル',
    image: yoshimuraMainImage,
    romajiName: 'yoshimura',
    modal: {
      description:
        '2016年リオデジャネイロオリンピック団体銀メダル、2017年世界選手権混合ダブルス優勝。 世界一のサーブと勝負強さが持ち味。',
      image: yoshimuraImage,
      lessons: [
        {
          image: yoshimuraLesson1Image,
          title: '吉村真晴の綺麗な姿勢の秘密',
        },
        {
          image: yoshimuraLesson2Image,
          title: '吉村真晴のロングサーブ対応での不意を突かれても必要な動き',
        },
        {
          image: yoshimuraLesson3Image,
          title:
            '吉村真晴の中陣バックカウンターはフリーハンドでボールに合わせる',
        },
      ],
    },
  },
  {
    name: '邱建新',
    title: 'コーチ',
    description1: '元日本代表コーチ',
    description2: '水谷隼選手などトップ選手のプライベートコーチの経験あり',
    image: qiuMainImage,
    romajiName: 'qiu',
    modal: {
      description:
        '日本男子ナショナルチームコーチ現任。水谷隼選手のプライベートコーチとして、リオオリンピックで個人銅メダルに導く。',
      image: qiuImage,
      lessons: [
        {
          image: qiuLesson1Image,
          title: '脱・中級者！勝たせる邱コーチの天才指導',
        },
        {
          image: qiuLesson2Image,
          title: '最新最強のバックを見て、すぐ上達！',
        },
        {
          image: qiuLesson3Image,
          title: '馬龍の秘技！アクティブ・ブロック',
        },
      ],
    },
  },
  {
    name: '山本怜',
    title: '選手',
    description1: '全日本学生チャンピオン',
    description2: '全日本選手権 ベスト16',
    image: yamamotoMainImage,
    romajiName: 'yamamoto',
    modal: {
      description:
        '十六銀行所属。中央大学、青森山田出身。女性らしい弱点のない卓球のポイントをお教えします。',
      image: yamamotoImage,
      lessons: [
        {
          image: yamamotoLesson1Image,
          title: '山本怜選手が教える「サーブ3球目、レシーブ4球目」',
        },
        {
          image: yamamotoLesson2Image,
          title: '山本怜のフォアドライブを強化する',
        },
        {
          image: yamamotoLesson3Image,
          title: '山本怜バック強化',
        },
      ],
    },
  },
  {
    name: '及川瑞基',
    title: '選手',
    description1: '全日本選手権一般男子 優勝',
    description2: '全日本学生 男子個人 優勝',
    image: oikawaMainImage,
    romajiName: 'oikawa',
    modal: {
      description:
        '青森山田高校出身。現在、専修大学ならびにドイツ一部プロチームに所属。全日本選手権大会ジュニア男子 優勝。軽快なフットワークからの連続攻撃は必見。',
      image: oikawaImage,
      lessons: [
        {
          image: oikawaLesson1Image,
          title: '全日本2021優勝記念!!及川瑞基と板垣監督の対談ライブ！',
        },
        {
          image: oikawaLesson2Image,
          title: 'プロで勝てるようになった3つの進化',
        },
        {
          image: oikawaLesson3Image,
          title: 'プロで勝てるようになった7つの進化',
        },
      ],
    },
  },
  {
    name: '鈴木李茄',
    title: '選手',
    description1: '全日本学生チャンピオン',
    description2: '全日本選手権 混合ダブルス3位',
    image: suzukiMainImage,
    romajiName: 'suzuki',
    modal: {
      description: '全日本学生チャンピオン/全日本選手権 混合ダブルス3位',
      image: suzukiImage,
      lessons: [
        {
          image: suzukiLesson1Image,
          title: '鈴木李茄のフォアドライブのミスを修正する',
        },
        {
          image: suzukiLesson2Image,
          title: '「女子選手の基本技術」逆横回転サーブに対するレシーブ',
        },
        {
          image: suzukiLesson3Image,
          title: '「女子選手の基本技術」ストップに対するバックハンドドライブ',
        },
      ],
    },
  },
  {
    name: '森薗政崇',
    title: '選手',
    description1: 'ダブルス世界選手権銀メダル',
    description2: '2020世界選手権シングルス日本代表',
    image: morizonoMainImage,
    romajiName: 'morizono',
    modal: {
      description:
        '2013年インターハイ男子シングルス優勝 / 2014、15年全日本卓球選手権大会男子ダブルス2連覇 / 2017年世界選手権男子ダブルス48年ぶりの銀メダル獲得',
      image: morizonoImage,
      lessons: [
        {
          image: morizonoLesson1Image,
          title: '森薗政崇の高速連打の秘密！ 誰よりも強くなる練習法',
        },
        {
          image: morizonoLesson2Image,
          title: '下回転に対するチキータ',
        },
        {
          image: morizonoLesson3Image,
          title: 'オールフォアのフットワーク「目的」',
        },
      ],
    },
  },
];
